import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=0087c46b&scoped=true&"
import script from "./Order.vue?vue&type=script&lang=ts&"
export * from "./Order.vue?vue&type=script&lang=ts&"
import style0 from "./Order.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Order.vue?vue&type=style&index=1&id=0087c46b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0087c46b",
  null
  
)

export default component.exports